import TouchableOpacity from '../../TouchableOpacity'
import Text from '../../Text'
import ListRow from '../../ListRow'
import ListRowAction from '../../ListRowAction'
import DeleteIcon from '../../../assets/icons/delete'
import { useEffect, useState, RefObject } from 'react'
import { deletePreset } from '../../../api/endpoints'
import type { Preset } from '@expostreamer/shared-types'
import styles from './style'

export interface InstanceViewHandle {
  show: (onClick: (preset: Preset) => void) => void
}

interface InstanceViewModalProps {
  instancePresets: Preset[]
  onPresetsChange?: (presets: Preset[]) => void
  ref?: RefObject<InstanceViewHandle | null>
}

function InstanceViewModal({ instancePresets, onPresetsChange, ref }: InstanceViewModalProps) {
  const [showInstanceSelectModal, setShowInstanceSelectModal] = useState(false)
  const [onClickHandler, setOnClickHandler] = useState<((preset: Preset) => void) | null>(null)
  const [deletingName, setDeletingName] = useState<string | null>(null)

  useEffect(() => {
    if (!ref) return

    ref.current = {
      show: onClick => {
        setShowInstanceSelectModal(true)
        setOnClickHandler(() => onClick)
      },
    }
  }, [ref])

  function handleDelete(preset: Preset) {
    if (!window.confirm(`Preset "${preset.name}" wirklich löschen?`)) return

    setDeletingName(preset.name)
    deletePreset(preset.name)
      .then(({ ok, data }) => {
        if (ok) onPresetsChange?.(data)
      })
      .finally(() => setDeletingName(null))
  }

  return showInstanceSelectModal ? (
    <div style={styles.container}>
      <div
        style={styles.backdrop}
        onClick={() => setShowInstanceSelectModal(false)}
      />

      <div style={styles.panel}>
        <div style={styles.header}>
          <Text style={styles.headerTitle}>Preset auswählen</Text>
          <TouchableOpacity onClick={() => setShowInstanceSelectModal(false)}>
            <Text style={styles.closeIcon}>✕</Text>
          </TouchableOpacity>
        </div>

        <div style={styles.list}>
          {instancePresets.length === 0 ? (
            <Text style={styles.emptyText}>Keine Presets vorhanden</Text>
          ) : (
            instancePresets.map(preset => (
              <ListRow
                key={preset.name}
                label={preset.name}
                disabled={deletingName === preset.name}
                onClick={() => {
                  onClickHandler?.(preset)
                  setShowInstanceSelectModal(false)
                }}
                actions={
                  <ListRowAction
                    disabled={deletingName === preset.name}
                    onClick={() => handleDelete(preset)}
                  >
                    <DeleteIcon
                      size={20}
                      color='#e05d5d'
                    />
                  </ListRowAction>
                }
              />
            ))
          )}
        </div>
      </div>
    </div>
  ) : null
}

export default InstanceViewModal
